import {Pipe, PipeTransform} from '@angular/core';
import {AbstractControl, FormArray, FormGroup} from "@angular/forms";

@Pipe({
    name: 'translationPanelValidationClass',
    pure: false,
    standalone: false
})
export class TranslationPanelValidationClassPipe implements PipeTransform {

    transform(translationsControl: FormArray, controlNames: string[] = []): { [p:string]: boolean } {

        let valid: boolean;

        if(Boolean(controlNames.length)){

            const controls: AbstractControl[] = [];

            translationsControl.controls.forEach((translationControl: FormGroup): void => {

                controlNames.forEach((controlName: string): void => {

                    if(translationControl.get(controlName) && (translationControl.get(controlName).status !== 'DISABLED')){

                        controls.push(translationControl.get(controlName));
                    }
                });
            });

            valid = controls.every((control: AbstractControl): boolean => {

                return control.valid;
            });
        }
        else {

            valid = translationsControl.controls.every((translationControl: FormGroup): boolean => {

                return translationControl.valid;
            });
        }

        return {
            'translation-panel-valid': valid,
            'translation-panel-invalid': !valid
        };
    }
}
